<template>
  <table style=" table-layout: fixed;border-collapse: collapse;">
    <tr>
      <td align="center" v-for="(s, idx) in social" :key="`social-${idx}`" style="padding: 0 8px;">
        <a :href="s.url" style="display: inline-block" target="_blank">
          <img
            :src="`https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/internal/social-${s.media}.png`"
            width="24"
            height="24"
          />
        </a>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'InternalSocial',
  data() {
    return {
      social: [
        {
          media: 'linkedin',
          url: 'https://www.linkedin.com/company/gtrsuite',
        },
        {
          media: 'twitter',
          url: 'https://twitter.com/gtrsuite',
        },
      ],
    }
  },
}
</script>
